import React, {type FC, memo} from 'react';

import {MetricsPickerDropdown} from './MetricsPickerDropdown';
import {MetricsPickerRegexInput} from './MetricsPickerRegexInput';
import {type MetricsPickerProps} from './MetricsPickerShared';

export type {
  MetricsPickerConfig,
  MetricsPickerProps,
} from './MetricsPickerShared';

export const MetricsPicker: FC<MetricsPickerProps> = memo(
  (props: MetricsPickerProps) => {
    if (props.config.useMetricRegex) {
      return <MetricsPickerRegexInput {...props} />;
    }

    return <MetricsPickerDropdown {...props} />;
  },
  metricsPickerPropsAreEqual
);

export function metricsPickerPropsAreEqual(
  prev: MetricsPickerProps,
  next: MetricsPickerProps
) {
  if (
    prev.config.useMetricRegex !== next.config.useMetricRegex ||
    prev.updateConfig !== next.updateConfig
  ) {
    return false;
  }

  if (next.config.useMetricRegex) {
    return (
      prev.config.metricRegex === next.config.metricRegex &&
      prev.keyInfo === next.keyInfo
    );
  }

  return (
    metricArraysEqual(prev.config.metrics, next.config.metrics) &&
    prev.options === next.options &&
    prev.keyTypes === next.keyTypes
  );
}

function metricArraysEqual(
  prevMetrics: string[] | undefined,
  nextMetrics: string[] | undefined
) {
  // MetricsPicker only consumes flat metric strings; keep the value fallback
  // here instead of stabilizing broad panel config upstream.
  if (prevMetrics === nextMetrics) {
    return true;
  }
  if (
    prevMetrics == null ||
    nextMetrics == null ||
    prevMetrics.length !== nextMetrics.length
  ) {
    return false;
  }
  for (let i = 0; i < prevMetrics.length; i++) {
    if (prevMetrics[i] !== nextMetrics[i]) {
      return false;
    }
  }
  return true;
}
